import { createMutation } from '$lib/api/tanstack-query';

import type { DeleteRobotReservationRequest } from '@viamrobotics/web-client/robotreservation/v1/robot_reservation';

import { useAuthContext } from '$lib/auth';

import { useRobotReservationClient } from '../client';
import { useQueryInvalidator } from '../invalidate';
import { tryAdminKeys, tryReservationsKeys } from './query-keys';

export const createDeleteTryReservationMutation = () => {
  const { getRPCOptions } = useAuthContext();
  const client = useRobotReservationClient();
  const { invalidateQueries } = useQueryInvalidator();

  return createMutation({
    mutationFn: async (request: DeleteRobotReservationRequest) => {
      const rpcOptions = await getRPCOptions();
      return client.deleteRobotReservation(request, rpcOptions);
    },
    onSuccess: async (_data, { id }) => {
      await invalidateQueries([
        tryReservationsKeys.active(),
        tryReservationsKeys.detail(id),
        tryReservationsKeys.allMachines(),
        tryAdminKeys.lists(),
      ]);
    },
  });
};
